import React from 'react';

import { AdminContextType } from 'packages/admin/types/admin.types';

const AdminContext = React.createContext<AdminContextType>({ companies: [] });

export default AdminContext;
